import type { RightTab } from "./utils/types";

export const CABLE_TAKEOFF_BETA_ORGANIZATION_IDS = [29, 31];

// Folder create/rename answer 409 when the name is already taken in the project.
export const HTTP_STATUS_CONFLICT = 409;

// Code tab ids are misleading ("cables" is routes); analytics gets clear names
export const ANALYTICS_TAB_BY_RIGHT_TAB = {
  plan: "elements",
  cables: "routes",
  cabletakeoff: "cableTakeoff",
} as const satisfies Record<Exclude<RightTab, "board">, string>;
